module.exports = __webpack_public_path__ + "img/画板 14.8ec58f47.jpg";